import { useEffect, useState } from "react"


import {
  ArrowLeftOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import { NodeTypes } from "@cloudike/web_files"
import { downloadAssetThunk } from "features/assets/model/slice/assetsSlice"
import { BoardToolbarAction } from "shared/constants/toolbar"
import { AUTH_MODAL_MODE, setAuthModalState } from "features/common/model/slice/appSlice"
import { openModal } from "features/common/model/slice/moadlSlice"
import { sharingActions } from "features/common/model/slice/sharingSlice"
import { downloadSharedFilesArchiveThunk } from "features/public-link-files/model/slice/publicLinkFilesSlice"
import { getFilesPublicLinkRootNodeTypeSelector } from "features/public-link-files/selectors/publicLinkFilesSelectors"
import { MemberRole } from "features/team/model/types/members"
import { getUserRole, userSelector } from "features/user/model/selectors/userSelectors"
import _ from "lodash"
import { useGetEnablePermission } from "features/public-link-files/hooks/useGetEnablePermission"
import { useSearchParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { SDK_TYPES } from "shared/sdk/sdkConstants"
import { Button } from "shared/ui"
import { hasAccess } from "shared/utils/access"
import styled from "styled-components"

import {
  getFilesPreviewCurrentBoardInfoSelector,
  getFilesPreviewIsPublicLinkSelector,
  getFilesPreviewItemsSelector,
  getFilesPreviewModalTypeSelector
} from "../model/selectors/filesPreviewSelectors"
import { getCurrentItemIndexByItemId } from "../utils/filesPreviewUtils"

import { SFileName, STopLeft, STopRight, STopRow } from "./styles"

const getShortFileName = (name: string) => {
  return name
}

export const FilesPreviewHeader = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()

  const items = useAppSelector(getFilesPreviewItemsSelector) as any
  const currentIndex = getCurrentItemIndexByItemId(items, searchParams.get('prv') || '')
  const user = useAppSelector(userSelector)
  const currentBoardInfo = useAppSelector(getFilesPreviewCurrentBoardInfoSelector)
  const isPublicLink = useAppSelector(getFilesPreviewIsPublicLinkSelector)
  const rootNodeType = useAppSelector(getFilesPublicLinkRootNodeTypeSelector)
  const userRole = useAppSelector(getUserRole)
  const modalType = useAppSelector(getFilesPreviewModalTypeSelector)
  const { isDownloadEnabled } = useGetEnablePermission()

  const [fileName, setFileName] = useState('')
  const currentItem = items[currentIndex]

  useEffect(() => {
    if(!currentItem?.name) return
    const fileName = getShortFileName(currentItem.name)
    setFileName(fileName)
  }, [currentItem])

  useEffect(() => {
    const handleResize = _.debounce(() => {
      if(!currentItem?.name) return
      const fileName = getShortFileName(currentItem.name)
      setFileName(fileName)
    }, 300)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [currentItem])

  const handleSharingButtonClick = () => {
    dispatch(openModal({ type: BoardToolbarAction.Share, context: 'board', data: { ids: [currentItem.id], items: [currentItem] } }))
    dispatch(sharingActions.setSharingAlbumConfig({
      sdkType: SDK_TYPES.FILES
    }))
    dispatch(sharingActions.setSharedItemData(currentItem))
  }

  const handleDownload = () => {
    const itemId = currentItem?.linked_node_id || currentItem.id
    isPublicLink ? dispatch(downloadSharedFilesArchiveThunk({ items: [currentItem] })) : dispatch(downloadAssetThunk({ id: itemId }))
  }

  const handleAuthClick = () => {
    dispatch(setAuthModalState({ isOpen: true, type: 'overlay', mode: AUTH_MODAL_MODE.SIGNIN }))
  }

  const handleCreateAccountClick = () => {
    dispatch(setAuthModalState({ isOpen: true, type: 'overlay', mode: AUTH_MODAL_MODE.SIGNUP }))
  }

  const handleSaveAiAssistantGenerated = () => {
    dispatch(openModal({ type: BoardToolbarAction.SaveAiAssistantGenerated, context: 'asset', data: { ids: [currentItem.id], items: [currentItem] } }))
  }

  return (
    <STopRow>
      {!(isPublicLink && (rootNodeType === 'link' || rootNodeType === NodeTypes.FILE)) && (
        <SBackIcon onClick={onClose} />
      )}

      <STopLeft>
        <SFileName>
          {fileName}
        </SFileName>

        {!!currentBoardInfo?.name && (
          <SBoardName>
            {currentBoardInfo?.name}
          </SBoardName>
        )}
      </STopLeft>

      <STopRight>
        {/* <SDropdownButton
        menu={{ items: menuItems }}
        placement="bottomLeft"
        getPopupContainer={() => document.body}
        buttonsRender={() => (
          [
            null,
            <SMoreIcon
              key='1'
            />
          ]
        )}
      /> */}

        {/* <SStarIcon /> */}
        {!isPublicLink && modalType !== 'ai-assistant-generated' && modalType !== 'ai-assistant-user' && hasAccess(userRole, [MemberRole.ADMIN, MemberRole.OWNER, MemberRole.USER]) && (
          <SShareButton
            color="default"
            variant="outlined"
            onClick={handleSharingButtonClick}
            size='middle'
          >
      Share
          </SShareButton>
        )}

        {
          modalType === 'ai-assistant-generated' && (
            <Button
              size='middle'
              variant="outlined"
              onClick={handleSaveAiAssistantGenerated}
            >
              Save
            </Button>
          )
        }

        {(!isPublicLink || (isPublicLink && !!user)) && isDownloadEnabled && (
          <SDownloadButton
            type="primary"
            size='middle'
            variant="solid"
            onClick={handleDownload}
          >
          Download
          </SDownloadButton>
        )}

        {
          isPublicLink && !user && (
            <>
              {isDownloadEnabled && (
                <SSmallButton
                  size='middle'
                  variant="outlined"
                  onClick={handleDownload}
                >
                  <DownloadOutlined />
                </SSmallButton>
              )}

              <SDivider />

              <Button
                size='middle'
                variant="outlined"
                onClick={handleAuthClick}
              >
              Log In
              </Button>

              <Button
                type="primary"
                size='middle'
                onClick={handleCreateAccountClick}
              >
              Create account
              </Button>
            </>
          )
        }
      </STopRight>
    </STopRow>
  )
}

const SBackIcon = styled(ArrowLeftOutlined)`
  color: rgba(255, 255, 255, 0.85);
  font-size: 24px;
`

const SShareButton = styled(Button)`

`

const SBoardName = styled.p`
  font-size: 14px;
  color: #FFFFFFA6;
  margin-top: 4px;
`

const SSmallButton = styled(Button)`
  padding: 0 8px;
`

const SDivider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #424242;
`

const SDownloadButton = styled(Button)`
  box-shadow: none !important;
  
  &:hover {
    box-shadow: none !important;
  }
  
  &:focus {
    box-shadow: none !important;
  }
  
  &:active {
    box-shadow: none !important;
  }
`
